// extracted by mini-css-extract-plugin
module.exports = {"charCount":"Details_charCount__gunU4"};